<template lang="pug">
v-container(fluid px-0 fill-height class=" tw-items-start tw-content-start tw-overflow-x-hidden tw-bg-blueGray-lighten-5 ")
  kubiqa-website-themes-theme-e-components-shared-top-navigation(class="tw-absolute tw-top-0 tw-left-0 tw-right-0 tw-z-10")
  div(class="tw-h-20") &nbsp;
  v-row(no-gutters align="center" justify="space-around" class=" tw-bg-blueGray-lighten-4 tw-h-26 tw-py-4")
    v-col(cols="12")
      div(class="tw-grid")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
          kubiqa-website-shared-widget-editor(
            page="contact"
            placement="header"
            @content="(content) => (content != null ? (defaultHeader = false) : (defaultHeader = true))"
          )
        div(v-if="defaultHeader" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12  tw-align-middle")
          div(class="tw-h-full  tw-items-center tw-flex")
            v-row(no-gutters justify="center")
              v-col(cols="9")
                span(class="tw-font-bold tw-text-white tw-text-2xl") Contact
  v-row(align="start" justify="center" class=" tw-bg-blueGray-lighten-5 tw-z-0 tw-py-8 flex-grow-1 d-fex flex-row  ")
    v-col(cols="6" align-self="stretch" class="")
      v-row(class=" tw-bg-white tw-border tw-border-gray-lighten-2 tw-rounded-md ")
        v-col
          v-row(class="tw-px-3 tw-pt-3")
            v-col
              v-text-field(filled label="Name")
            v-col
              v-text-field(filled label="Email")
          v-row(dense class="tw-pt-0")
            v-col
              v-textarea(filled height="400px" class="mx-3")
          v-row(no-gutters)
            v-col(class="tw-pt-0 tw-ml-3")
              v-btn(
                x-large
                @click="method"
                width="200"
                height="60"
                color="teal lighten-2"
                elevation="0"
                class="tw-mt-0"
              )
                span(class="tw-font-bold") Send

    v-col(cols="5" class="tw-px-10" align-self="stretch")
      div(class="tw-grid fill-height")
        div(class="tw-z-10 tw-row-span-full tw-col-span-12 tw-col-start-1 ")
          kubiqa-website-shared-widget-editor(
            page="contact"
            placement="description"
            @content="(content) => (content != null ? (defaultDescription = false) : (defaultDescription = true))"
            class=" fill-height"
          )
        div(v-if="defaultDescription" class="tw-z-0 tw-row-span-full tw-col-start-1 tw-col-span-12 tw-align-middle")
          v-row
            v-col(cols="stretch" class="tw-pt-4 tw-text-left")
              span(class="tw-text-lg tw-font-medium tw-pt-4  tw-text-left") {{ this.$faker().lorem.paragraphs(1) }}

          v-row(justify="space-around" align="center" class="tw-mt-8")
            v-col(cols="auto")
              v-icon(x-large color="blue") mdi-home-city-outline
            v-col(cols="10")
              div
                span {{ this.$faker().address.streetAddress(useFullAddress) }}
              div
                span {{ this.$faker().address.city() }}, {{ this.$faker().address.state() }}

          v-row(justify="space-around" align="center" class="tw-mt-4")
            v-col(cols="auto")
              v-icon(x-large color="blue") mdi-phone-classic
            v-col(cols="10")
              div
                span {{ this.$faker().phone.phoneNumber() }}

          v-row(justify="space-around" align="center" class="tw-mt-4")
            v-col(cols="auto")
              v-icon(x-large color="blue") mdi-email-outline
            v-col(cols="10")
              div
                span {{ this.$faker().internet.email() }}

  v-row(class="tw-pt-24 ")
    v-col

  kubiqa-website-themes-theme-e-components-shared-footer
</template>
<script>
export default {
  data() {
    return {
      defaultHeader: null,
      defaultDescription: null,
    };
  },
};
</script>
<style lang="stylus">
.filters-active
    background-color: #ffffff


:focus
    outline: 0 !important
</style>
